__turbopack_context__.v({
  "main": "HomeContent-module__nUCKLW__main",
});
